"use client";

import { useContext, useState } from "react";
import fileDownload from "js-file-download";
import { Button } from "@mui/material";
import TokenContext from "@/context/TokenProvider";
import MenuContext from "@/context/MenuProvider";
import axios from "axios";

const UnduhSurat = (props: React.ComponentProps<typeof Button>) => {
  const { accessToken } = useContext(TokenContext)!;
  const { setStateAlertDialog } = useContext(MenuContext)!;
  const [loading, setLoading] = useState(false);

  const unduhSurat = async (e) => {
    setLoading(true);
    try {
      e.preventDefault();
      const response = await axios.get(
        `${process.env.NEXT_PUBLIC_API_URL}/v2/sbp`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
          responseType: "blob"
        }
      );
      fileDownload(response.data, `Surat-Bebas-Perpus.pdf`);
    } catch (error) {
      if (error.response) {
        setStateAlertDialog({
          isOpen: true,
          title: "Pengunduhan Surat Gagal",
          content: error.response.data.message,
          severity: "error"
        });
      }
    }
    setLoading(false);
  };



  return <Button
    variant="contained"
    onClick={unduhSurat}
    {...props}
  >
    Unduh Surat
  </Button>;

};

export default UnduhSurat;
